import { render, staticRenderFns } from "./LeaveAttachmentPreview.vue?vue&type=template&id=120b0238&scoped=true"
import script from "./LeaveAttachmentPreview.vue?vue&type=script&lang=js"
export * from "./LeaveAttachmentPreview.vue?vue&type=script&lang=js"
import style0 from "./LeaveAttachmentPreview.vue?vue&type=style&index=0&id=120b0238&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "120b0238",
  null
  
)

export default component.exports